import * as React from "react";
import { Image } from "../../image/image.mjs";
const SectionImage = (props) => {
  return /* @__PURE__ */ React.createElement("div", { className: "section__image-container" }, /* @__PURE__ */ React.createElement(Image, { ...props, className: "section__image" }));
};
export {
  SectionImage
};
